/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NativeTokenAdapter,
  NativeTokenAdapterInterface,
} from "../NativeTokenAdapter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridge",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "FailedFundsTransfer",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientBalance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "InsufficientMsgValueAmount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MsgValueLowerThanFee",
    type: "error",
  },
  {
    inputs: [],
    name: "SenderNotAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroGas",
    type: "error",
  },
  {
    inputs: [],
    name: "_bridge",
    outputs: [
      {
        internalType: "contract IBridge",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_resourceID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "recipientAddress",
        type: "string",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "depositToEVM",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "gas",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "message",
        type: "bytes",
      },
    ],
    name: "depositToEVMWithMessage",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "depositDataAfterAmount",
        type: "bytes",
      },
    ],
    name: "depositGeneral",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "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";

type NativeTokenAdapterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NativeTokenAdapterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NativeTokenAdapter__factory extends ContractFactory {
  constructor(...args: NativeTokenAdapterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NativeTokenAdapter";
  }

  deploy(
    bridge: string,
    resourceID: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NativeTokenAdapter> {
    return super.deploy(
      bridge,
      resourceID,
      overrides || {}
    ) as Promise<NativeTokenAdapter>;
  }
  getDeployTransaction(
    bridge: string,
    resourceID: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridge, resourceID, overrides || {});
  }
  attach(address: string): NativeTokenAdapter {
    return super.attach(address) as NativeTokenAdapter;
  }
  connect(signer: Signer): NativeTokenAdapter__factory {
    return super.connect(signer) as NativeTokenAdapter__factory;
  }
  static readonly contractName: "NativeTokenAdapter";
  public readonly contractName: "NativeTokenAdapter";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NativeTokenAdapterInterface {
    return new utils.Interface(_abi) as NativeTokenAdapterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NativeTokenAdapter {
    return new Contract(address, _abi, signerOrProvider) as NativeTokenAdapter;
  }
}
